export default __webpack_public_path__ + "static/vutlan-ad48dc2d89a2934e8d0bc071874497f4.png";